<template>
  <section class="page-section" :aria-labelledby="title ? sectionTitleId : undefined" :aria-label="title ? undefined : ariaLabel">
    <div v-if="title || description || $slots.actions" class="page-section__header">
      <div class="page-section__heading">
        <h2 v-if="title" :id="sectionTitleId" class="page-section__title">{{ title }}</h2>
        <p v-if="description" class="page-section__description">{{ description }}</p>
      </div>
      <page-actions v-if="$slots.actions" :aria-label="actionsLabel">
        <slot name="actions" />
      </page-actions>
    </div>
    <div class="page-section__body">
      <slot />
    </div>
  </section>
</template>

<script>
import { getCurrentInstance } from 'vue'
import PageActions from './PageActions.vue'

export default {
  name: 'PageSection',
  components: { PageActions },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    ariaLabel: {
      type: String,
      default: 'Раздел страницы'
    },
    actionsLabel: {
      type: String,
      default: 'Действия раздела'
    }
  },
  setup() {
    const instance = getCurrentInstance()
    return { sectionTitleId: `page-section-${instance.uid}-title` }
  }
}
</script>

<style scoped>
.page-section {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.page-section + .page-section {
  margin-top: var(--sid-space-6);
  padding-top: var(--sid-space-6);
  border-top: 1px solid var(--sid-color-line);
}

.page-section__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sid-space-4);
  margin-bottom: var(--sid-space-4);
}

.page-section__heading {
  min-width: 0;
}

.page-section__title,
.page-section__description {
  margin: 0;
}

.page-section__description {
  margin-top: var(--sid-space-1);
  color: var(--sid-color-text-secondary);
}

.page-section__body {
  min-width: 0;
}

@media (max-width: 599px) {
  .page-section__header {
    flex-direction: column;
  }
}
</style>
